var scope_0 = require('/Users/abdullah/dev/abba.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b465577be36407976d85905b67378686.js').default;
var scope_1 = require('/Users/abdullah/dev/abba.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf7a3983568745f6aa1457735c45107b.js').default;
var scope_2 = require('/Users/abdullah/dev/abba.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d2ad75076d147ce06f2988b25459c6fb.js').default;
var scope_3 = require('/Users/abdullah/dev/abba.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    